import React from 'react';
import AuthService from './authService.js';

export default class PublicHolidayService extends React.Component {
  static Get(officeId, year) {
    const authService = AuthService.getInstance();
    const url = `/api/PublicHoliday/Get?officeId=${officeId}&year=${year}&clearCache=true`;
    return authService.CallBackendFunction(url);
  }

  static Save(item) {
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost('/api/PublicHoliday/Save', JSON.stringify(item));
  }

  static Delete(id) {
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(`/api/PublicHoliday/Delete?id=${id}`, JSON.stringify({}));
  }
}
